<template xmlns="http://www.w3.org/1999/html">
  <div>
    <el-container class="container">
      <el-header class="el-header" style="margin-top: 50px"><strong><br/><br/>研究者主页<br/><br/>
        Researcher’s Homepage
      </strong>
        <div>
        <el-button type="primary"
                   style="justify-content: right;float: right; width: 150px; height: 80px;" @click="$router.push('/Homeindex')">
          返回主页<br/><br/>
          Back to Home
        </el-button>
        </div>

      </el-header>
<!--        功能按钮-->

      <el-row :gutter="20">
        <el-col :span="3">
          <div class="Reintro">
            TALL (Tests of Aptitude for Language Learning) is an internet-based research instrument
            designed to measure language learning aptitude. It was developed originally for a
<!--            Junlan Pan for her-->
            PhD project and is currently a free and open accessible research tool that can be used by other researchers. Data at the item level collected by TALL are available for download.
            <br/>Please follow the instructions to navigate the test platform in the role of either
            researcher or test-taker. If you are a researcher who wants to use TALL to collect data, you'll need to generate test codes
            for your participants by clicking "Participants' Test Codes".
            <br>
            If you have any questions, please contact <a href="mailto:tall-webtest@foxmail.com.">  tall-webtest@foxmail.com.</a>
            <br/>
            <br/>
<!--            盘峻岚为其-->
            语言学能测试（简称TALL）是基于互联网的语言学能测量工具。它最初是为
            博士项目设计开发的数据收集工具，目前已实现开放获取，供其他研究者免费使用，它收集的测试数据也可以下载。
            <br/>请按照说明，以研究者或被测者的身份进入测试平台。
            如果您是研究者需要使用TALL进行数据收集，可以点击“测试邀请码生成及管理”生成测试码发给被试。
            <br>
            如有疑问，请联系<a href="mailto:tall-webtest@foxmail.com.">  tall-webtest@foxmail.com</a>


          </div>
        </el-col>
        <el-col :span="15">
          <el-row class="el-row">
            <div class="function_button">
              <el-button type="primary" @click="testintro">测试说明手册<br/><br/>
                Test Manuals
              </el-button>
            </div>
            <div class="function_button">
              <el-button type="primary" @click="invite_code">测试码生成及管理<br/><br/>
                Participants’ Test Codes
              </el-button>
            </div>


          </el-row>

          <el-row class="el-row">
            <div class="function_button">
              <el-button type="primary" @click="demo">测试演示<br/><br/>
                Demo Test
              </el-button>
            </div>

            <div class="function_button">
              <el-button type="primary" @click="datadownup">数据下载和上传<br/><br/>
                Data Download and Upload
              </el-button>
            </div>

          </el-row>

          <el-row class="el-row" >
            <div class="function_button">
              <el-button type="primary" @click="faqupdates">常见问题<br/><br/>
                FAQs
              </el-button>
            </div>
            <div class="function_button">
              <el-button type="primary" @click="research">相关研究<br/><br/>
                TALL Outputs
              </el-button>
            </div>

          </el-row>
        </el-col>


      </el-row>

      <el-dialog
          title="Researher Functions"
          :visible.sync="centerDialogVisible"
          width="70%"
          style="font-size: 26px;"
          left>
          <span>
            <div v-show="showfunction==0" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3>Test Manuals</h3>
              </div>
              <div style="height: 400px">
                  <el-col :span="15">
                    <p style="font-size: 16px; margin-top: 30px" >TALL_VL: Vocabulary Learning</p>
                    <p style="font-size: 16px; margin-top: 30px">TALL_SD: Sound Discrimination</p>
                    <p style="font-size: 16px; margin-top: 30px">TALL_LA: Language Analysis</p>
                    <p style="font-size: 16px; margin-top: 30px">TALL_WM: Working Memory</p>
                    <p style="font-size: 16px;margin-left: 30px; margin-top: 30px">Part 1  SNWR: Serial Nonword Recall</p>
                    <p style="font-size: 16px;margin-left: 30px; margin-top: 30px">Part 2  CST: Complex Span Tasks</p>

                  </el-col>
                 <el-col :span="3">
                     <el-button class="manual" id="VL" type="primary" @click="ManualPage"
                                style="margin-top:22px; margin-left: 50px; width: 100px; height: 40px">
                  Manual
                </el-button>
                    <el-button class="manual"id="SD" type="primary" @click="ManualPage1"
                               style="margin-top:7px;margin-left: 50px; width: 100px; height: 40px">
                  Manual
                </el-button>
                   <el-button class="manual"id="LA" type="primary" @click="ManualPage2"
                              style="margin-top:7px;
                              margin-left: 50px; width: 100px; height: 40px">
                  Manual
                </el-button>
                  <el-button class="manual"id="part1" type="primary" @click="ManualPage3"
                             style="margin-top:65px;margin-left: 50px; width: 100px; height: 40px; margin-top: 50px">
                  Manual
                </el-button>
                <el-button class="manual"id="part2" type="primary" @click="ManualPage4"
                           style="margin-top:7px;margin-left: 50px; width: 100px; height: 40px">
                  Manual
                </el-button>
                  </el-col>
<!--              <p style="font-size: 16px" >TALL_VL: Vocabulary Learning-->
<!--                <el-button class="manual" id="VL" type="primary" @click="ManualPage" style="margin-left: 100px; width: 100px; height: 40px">-->
<!--                  Manual-->
<!--                </el-button>-->
<!--              </p>-->
<!--              </div>-->
<!--               <p style="font-size: 16px">TALL_SD: Sound Discrimination-->
<!--                <el-button class="manual"id="SD" type="primary" @click="ManualPage1" style="margin-left: 100px; width: 100px; height: 40px">-->
<!--                  Manual-->
<!--                </el-button>-->
<!--              </p>-->
<!--               <p style="font-size: 16px">TALL_LA: Language Analysis-->
<!--                <el-button class="manual"id="LA" type="primary" @click="ManualPage2" style="margin-left: 100px; width: 100px; height: 40px">-->
<!--                  Manual-->
<!--                </el-button>-->
<!--              </p>-->
<!--               <p style="font-size: 16px">TALL_WM: Working Memory-->

<!--              </p>-->
<!--               <p style="font-size: 16px;margin-left: 30px">Part 1  SNWR: Serial Nonword Recall-->
<!--                <el-button class="manual"id="part1" type="primary" @click="ManualPage3" style="margin-left: 100px; width: 100px; height: 40px">-->
<!--                  Manual-->
<!--                </el-button>-->
<!--              </p>-->
<!--              <p style="font-size: 16px;margin-left: 30px">Part 2  CST: Complex Span Tasks-->
<!--                <el-button class="manual"id="part2" type="primary" @click="ManualPage4" style="margin-left: 100px; width: 100px; height: 40px">-->
<!--                  Manual-->
<!--                </el-button>-->
<!--              </p>-->
              </div>

            </div>
            <div v-show="showfunction==1" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3>Access Codes for Test</h3>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="generate_code">生成邀请码<br/><br/>
                  Generate test codes
                </el-button>
                <el-button type="primary" @click="mycode">我生成的邀请码<br/><br/>
                  Codes I generated
                </el-button>
              </div>
            </div>

            <div v-show="showfunction==2" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3>FAQs and Updates</h3>
              </div>
              <div style="white-space: pre-wrap; word-break: break-word;">
                This page contains answers to queries that researchers may want to know more about TALL (Tests of Aptitude in Language Learning).
                <h4>What is TALL?</h4>
                TALL (Tests of Aptitude in Language Learning) is an internet-based
                research instrument designed to measure language learning aptitude. It was developed originally by Junlan Pan for her PhD project and is currently an already free and open accessible research tool that can be used by other researchers.
                <h4>Where is TALL hosted? Who maintains the site?</h4>
                TALL was powered by a commercial service Tencent Cloud based in China,
                with T-Sec host security for privileged clients. The upkeep of test platform
                and backend database is provided by a small team in the School of Foreign
                Languages & Cultures (FLC) at Chongqing University. TALL was initially funded by FLC and has been led by Junlan Pan.

                <h4>Is TALL (Version 1) ready for use?</h4>
                Yes. TALL (Version 1) is currently available for use.
                Comments are welcome by contacting  <a href="mailto:tall-webtest@foxmail.com">  tall-webtest@foxmail.com</a>.

                <h4>Will TALL record data so that researchers can do data analysis at the item level?</h4>
                Yes.

                <h4>How can I access the data collected by TALL?</h4>
TALL saves the data it collects and associates the data with individual access code researchers generate for participants’ use. After you generate access codes through “Participants’ Access Codes”, you can download the spreadsheets containing the access codes.  (It would be a good practice if you can keep the record of the access codes you have distribute to your participants. )
Once your participants complete TALL, you can use your ID (the email you used for registration) to access and download the data of your participants through “Data Download and Upload”.
Please note that only the complete data of TALL (that is, participants complete five all subtests) can be accessible and downloadable.

                <h4>How can I get the scores of the first part of Working Memory subtest?</h4>
The first part of Working Memory subtest is Serial Nonword Recall (SNWR). Once your participants complete all subtests, the raw data (i.e., the recordings of participants’ performance) is available for download. You need to score the recordings and generate the data for your own analysis.
We invite you to upload the scored data set of SNWR to TALL. Your contribution will help TALL build an open data pool.

                <h4>What happen to the data collected by TALL?</h4>
                Data collected by TALL comply with the General Data Protection Regulation (GDPR) (https://www.york.ac.uk/education/research/gdpr_information/) in the ethical approval the initial PhD project of Junlan Pan was granted. A dual strategy of carrying out regular back-up on both the server and local backend has been implemented to maintain the database of TALL. The backup data has been archived in the School of Foreign Languages & Cultures (FLC) at Chongqing University. In the long run, TALL will be developed into an open data tool with an accumulative open data pool, which aims to be designated by the <a href="https://www.cos.io/">Center for Open Science </a> as a recognised repository for open data.

                <h4>Can I use TALL with children?</h4>
TALL was designed to be used with adults. The tests may work with adolescents if their L1 literacy levels are above medium (equivalent to post elementary schools). It is not recommended to be used with younger children.

                <h4>Are TALL tests L1-independent?</h4>
No. TALL (Version 1) can only be used with participants who have Mandarin Chinese as their first language. Research collaborations are welcome if you are interested in adapting TALL for participants having other L1s.

                <h4>Should I use both test suites of TALL in my research?</h4>
This depends on what you aim to investigate in your research. TALL tests can be administered using the aural and the written suites. Each suite can be used independently, and each has two versions of test items that are counter balanced.

                <h4>Can I access and use the materials of TALL in my own research?</h4>
Yes. All materials, including the pictorial, aural and written stimuli, of TALL are openly accessible in the IRIS database
                ( <a href="http://www.iris-database.org"> www.iris-database.org</a>) under a Creative Commons licence that allows others to change or adapt them.
We value and advocate the merits of Open Science in the field of Applied Linguistics. The “Attribution-Noncommercial_Sharealike” option of the Creative Commons licence we choose requires others give subsequent adaptations the same licence.

                <h4>How should I cite TALL tests when I use them?</h4>
Please cite TALL as:
Pan, J. and Marsden, E. (2023) Developing an internet-based Tests of Aptitude in Language Learning (TALL): An open research endeavour. Language Testing.

                <h4>Where can I find research about TALL or research that uses TALL?</h4>
Please check out the “TALL Outputs” page.

              </div>

            </div>

            <div v-show="showfunction==3" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3>
                  Datasets Download and Upload for research purposes
                </h3>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="download_data">下载假词复述音频<br/><br/>
                   Download Non-word Recordings
                </el-button>
                <el-button type="primary" @click="upload_rate">上传假词复述评分数据<br/><br/>
                  Upload Non-word Recall Scores
                </el-button>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="download_data1">下载邀请码关联数据<br/><br/>
                    Download Code-related Datasets
                </el-button>
                <el-button type="primary" @click="download_score">下载成绩报告<br/><br/>
                 Download Code-related Report
                </el-button>
              </div>
            </div>
            <div v-show="showfunction==4" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3> Demo Test</h3>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="demo_A">测试演示（试听版）<br/><br/>
                  Demo Test (the aural suite)
                </el-button>
                <el-button type="primary" @click="demo_W">测试演示（文字版）<br/><br/>
                  Demo Test (the written suite)
                </el-button>

              </div>
            </div>

          </span>

      </el-dialog>

    </el-container>

  </div>

</template>

<script>
import GLOBAL from "../../src/plugins/global_variable";
import JSZip from "jszip";
import saveAs from 'file-saver';

var zip = new JSZip();
export default {
  name: "Researcherindex",
  data() {
    return {
      Reemail: GLOBAL.Reemail,

      item: [],
      //音频文件数组
      blob: [],
      //字典 这里暂时用手动输入
      record_dict: [],
      //获取到的文件长度
      resultLength: 0,
      //记录长度  方法重调用 变量会重载
      result_len: 0,
      centerDialogVisible: false,
      showfunction:'',
    }


  },
  methods: {

    generare_record_dict() {
      //生成答案字典

      var index = 0   //获取数组索引增值
      let pos = 0    //索引位移量
      let k = 1     //组别标记

      //训练音频组答案
      for (let j = 2; j <= 5;) {
        for (let i = 0; i < j; i++ , index++) {
          this.record_dict['A_L' + k + '_' + parseInt(i + 1)] = GLOBAL.pronuncationsA[i + pos]
          this.record_dict['B_L' + k + '_' + parseInt(i + 1)] = GLOBAL.pronuncationsB[i + pos]
        }
        pos = index  //赋予位移量
        if (j == 3) {
          j = 5;
          k = 3
        } else {
          k++
          j++
        }

      }

      //测试音频组答案
      k = 1 //组别标记重置
      for (let j = 2; j <= 7; j++) {
        for (let p = 0; p < 3; p++) {
          for (let i = 0; i < j; i++ , index++) {
            this.record_dict['A_T' + k + '_' + parseInt(i + 1)] = GLOBAL.pronuncationsA[i + pos]
            this.record_dict['B_T' + k + '_' + parseInt(i + 1)] = GLOBAL.pronuncationsB[i + pos]
          }
          pos = index
          k++
        }
      }
    },
    zip_resource() {
      console.log("打包方法被调用了")
      var _this = this;
      console.log("item长度", _this.item.length)
      console.log("item", _this.item)
      console.log("blob", _this.blob)


      //保存成zip文件
      for (let i = 0; i < _this.item.length; i++) {
        let data
        console.log(_this.blob[_this.item[i].id])
        //todo _this.item[i].id
        _this.blob[_this.item[i].id] = new Blob([_this.blob[_this.item[i].id]], {
          type: 'audio/mp3'
        })

        let file_name = 'aural-' + _this.item[i].user + '-' + _this.item[i].recordType + '-' + _this.record_dict[_this.item[i].recordType] + '-' + _this.item[i].session + '.mp3'


        zip.file(file_name, _this.blob[_this.item[i].id]);


        // FileSaver.saveAs(_this.blob[_this.item[i].recordType],_this.item[i].user+'-'+_this.item[i].recordType+'-'+_this.record_dict[_this.item[i].recordType]+'-'+_this.value+'.mp3',{type:"audio/mp3"})
      }
      zip.generateAsync({type: "blob"})
          .then(function (content) {
            // console.log(content,"content")
            // if(content.size<500000){
            //   _this.$message.error('资源预加载完成，请重新点击下载');
            //
            //
            // }else {
            //
            // }
            saveAs(content);
          });
    },
    async getRecordsMp3(email, recordType, id) {
      var _this = this;

      //console.log("延时调用了")
      // + email + '/' + recordType + '/' + _this.value+ '/'
      await axios.get('/test4record/send_record/' + id, {responseType: 'blob'}).then(function (resp) {
        //获取相应的数据信息进行封装 （包含测试内容

        //todo 这个会直接导致覆盖问题出现  看看能不能换成id来下载
        _this.blob[id] = new Blob([resp.data], {
          type: 'audio/mp3'
        })
        // console.log("执行递归",_this.blob[recordType])
        _this.result_len = _this.result_len + 1
        console.log("记录长度", _this.result_len, "真实长度", _this.resultLength)
        if (_this.result_len == _this.resultLength) {


          _this.zip_resource()
          _this.result_len = 0
          _this.item = []
        }


      });

    },
    async getRecords() {
      var _this = this;

      //根据数据长度分批次获取音频文件（一次性传输问题有待解决
      await axios.get('researcher/send_records/' + _this.Reemail,).then(function (resp) {
        console.log(resp.data, "文件内容")

        _this.$message.success('Searching for resources, please be patient');
        _this.resultLength = resp.data.length
        for (var i = 0; i < resp.data.length; i++) {
          _this.item.push({
            'id': resp.data[i]["id"],
            'user': resp.data[i]["email"],
            'recordType': resp.data[i]["recordType"],
            'session': resp.data[i]["session"]
          })
          _this.getRecordsMp3(resp.data[i]["email"], resp.data[i]["recordType"], resp.data[i]["id"])
        }
        console.log('blob', _this.blob)
        // console.log('item',_this.item)


      });


    },

    async download_data() {
      var _this = this;
      let fileName = "Download code-related data.zip"
      console.log("xizai")
      await _this.getRecords()
      // axios({
      //   url: "/researcher/send_records/" + this.Reemail,
      //   responseType: 'blob'
      // }).then((response) => {
      //   const content = response.data
      //   const blob = new Blob([content], {type: "zip"})
      //   if ('download' in document.createElement('a')) { // 非IE下载
      //     const elink = document.createElement('a')
      //     elink.download = fileName
      //     elink.style.display = 'none'
      //     elink.href = URL.createObjectURL(blob)
      //     document.body.appendChild(elink)
      //     elink.click()
      //     URL.revokeObjectURL(elink.href) // 释放URL 对象
      //     document.body.removeChild(elink)
      //     this.generate = !this.generate
      //   } else { // IE10+下载
      //     navigator.msSaveBlob(blob, fileName)
      //   }
      // });
    },

    upload_rate() {
      this.$router.push('/Researcherupload');
    },

    download_score() {
      this.$router.push('/Researcherreport');
    },

    ManualPage(){
      window.open('../../pdf/1_TALL_VL_manual.pdf', '_blank')
      // window.open('../pdf/1_TALL_VL_manual.pdf','_blank') // 在新窗口打开外链接
    },

    ManualPage1(){
      window.open('../pdf/2_TALL_SD_manual.pdf','_blank') // 在新窗口打开外链接
    },
    ManualPage2(){
      window.open('../pdf/3_TALL_LA_manual.pdf','_blank') // 在新窗口打开外链接

    },
    ManualPage3(){
      window.open('../pdf/4_TALL_SNWR_manual.pdf','_blank') // 在新窗口打开外链接

    },
    ManualPage4(){
      window.open('../../pdf/5_TALL_CST_manual.pdf','_blank') // 在新窗口打开外链接

    },

    testintro(){
      this.centerDialogVisible=true
      this.showfunction=0
    },


    invite_code(){
      this.centerDialogVisible=true
      this.showfunction=1
    },

    generate_code() {
      this.$router.push('/Researchercode');
    },

    research(){},

    mycode() {
      var _this = this;
      axios.get('/invite/findByR_email' + _this.Reemail).then((resp) => {
            var codelist = resp.data
            GLOBAL.codeinfolist = codelist
            console.log(GLOBAL.codeinfolist)
          }
      );

      _this.$router.push('/Researcherviewcode');
    },

    faqupdates(){
      this.centerDialogVisible=true
      this.showfunction=2
    },

    datadownup(){
      this.centerDialogVisible=true
      this.showfunction=3
    },

    download_data1() {
      let fileName = "tall_researcher.zip"
      axios({
        url: "/openData/downloadByRemail?remail=" + this.Reemail,
        responseType: 'blob'
      }).then((response) => {
        const content = response.data
        const blob = new Blob([content], {type: "zip"})
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
          this.generate = !this.generate
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      });
    },
    demo(){
      this.centerDialogVisible=true
      this.showfunction=4
    },

    demo_A() {
      this.$router.push('/Demo/Index');
    },
    demo_W() {
      this.$router.push('/Demo_w/Index');
    },
  },
  created() {
    //生成答案字典
    this.generare_record_dict()

    console.log(this.record_dict)


  }
}
</script>

<style scoped>
.el-header{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 10px;
  justify-content: center;
  font-size: 24px;
  text-align: center;
  background-color: #D8D8D8;
}
.container{
  background-color: #DCDCDC ;
  display: flex;
  flex-direction: column;
  height: 1000px;
}

.Reintro{
  font-size:20px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: left;
  margin-top: 3rem;
  margin-left: -90px;
  width: 450px;
}

.el-row{
  font-size:20px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin-top: 5rem;
  margin-right: -150px;
  margin-left: 150px;
}
.function_button{
  margin-left: 20px;

}

.el-button{
  width: 300px;
  height: 80px;
}

.manual{
  width: 300px;
  height: 80px;
  justify-content: right;
}

</style>